var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoInvoicesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 203,
    viewBox: "0 0 212 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8121 85.363H138.056C140.962 85.363 143.166 87.5674 143.166 90.4732V136.265C143.166 139.17 140.962 141.375 138.056 141.375H65.8121C62.9063 141.375 60.7019 139.17 60.7019 136.265V90.4732C60.7019 87.5674 63.1067 85.363 65.8121 85.363Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.569 114.722V137.267C144.569 140.172 142.264 142.577 139.258 142.577H65.0103C62.1045 142.577 59.6997 140.172 59.6997 137.267V112.818",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.257 102.096H114.81C112.505 102.096 110.301 102.898 108.598 104.301L102.485 109.311C100.782 110.714 98.5776 111.515 96.273 111.515H69.8202C67.1148 111.515 64.9104 113.72 64.9104 116.425C64.9104 116.625 64.9104 116.926 65.0106 117.126L69.9204 142.978C70.3212 145.383 72.3252 147.186 74.8302 147.186H131.443C133.848 147.186 135.952 145.483 136.353 143.078L143.167 107.708C143.668 105.002 141.864 102.597 139.159 102.096C138.758 102.096 138.457 102.096 138.257 102.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.778 95.1826H118.317C115.311 95.1826 112.505 96.1846 110.201 98.0884L102.185 104.601C99.9803 106.405 97.0745 107.507 94.0685 107.507H59.5997C56.0927 107.507 53.2871 110.413 53.2871 113.82C53.2871 114.12 53.2871 114.421 53.3873 114.722L59.6999 148.489C60.2009 151.695 62.9063 154 66.0125 154H139.76C142.966 154 145.571 151.796 146.072 148.589L154.99 102.397C155.591 98.89 153.287 95.7838 149.78 95.0824C149.479 95.1826 149.078 95.1826 148.778 95.1826Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8603 130.152C91.6639 130.152 93.1669 128.649 93.1669 126.846C93.1669 125.042 91.6639 123.539 89.8603 123.539C88.0567 123.539 86.5537 125.042 86.5537 126.846C86.5537 128.649 88.0567 130.152 89.8603 130.152Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.611 130.052C117.415 130.052 118.918 128.549 118.918 126.746C118.918 124.942 117.415 123.439 115.611 123.439C113.808 123.439 112.305 124.942 112.305 126.746C112.305 128.649 113.808 130.052 115.611 130.052Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6777 106.405C95.0705 99.3911 94.2689 90.9743 96.6737 83.3591C98.9783 75.7439 104.489 69.2309 111.303 65.5235C113.407 64.4213 115.812 63.5195 118.217 63.4193C120.621 63.3191 123.227 64.1207 124.83 66.1247C126.433 67.9283 126.734 70.9343 125.431 72.9383C124.028 74.8421 121.223 75.6437 118.918 75.0425C115.211 74.3411 112.205 71.4353 111.303 67.9283C110.401 64.4213 111.603 60.3131 114.409 58.0085C116.213 56.4053 118.718 55.5035 121.022 54.8021C132.245 51.4955 144.469 51.0947 155.892 53.5997",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.892 133.659H99.6799V135.162H105.892V133.659Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.904 50.9944C161.804 52.4974 161.704 53.9002 160.601 54.2008C159.499 54.5014 158.998 53.4994 158.297 52.0966C157.595 50.794 157.996 49.3912 159.199 49.0906C160.301 48.79 162.104 49.1908 161.904 50.9944Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.702 58.2088C161.002 56.4052 161.303 55.4032 160.301 54.9022C159.199 54.4012 158.497 55.303 157.295 56.5054C156.293 57.6076 156.894 59.2108 157.896 59.7118C159.098 60.313 160.401 59.7118 160.702 58.2088Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.104 54.9023C162.004 55.6037 161.503 56.1047 160.802 56.2049C160.501 56.2049 160.2 56.2049 159.8 56.2049C158.397 56.0045 157.295 55.1027 157.395 54.2009C157.495 53.2991 158.798 52.7981 160.401 52.9985C160.701 52.9985 161.002 53.0987 161.202 53.1989C161.804 53.3993 162.204 54.1007 162.104 54.9023C162.104 54.8021 162.104 54.9023 162.104 54.9023Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.104 54.9023C162.004 55.6037 161.503 56.1047 160.802 56.2049C160.501 56.2049 160.2 56.2049 159.8 56.2049C158.397 56.0045 157.295 55.1027 157.395 54.2009C157.495 53.2991 158.798 52.7981 160.401 52.9985C160.701 52.9985 161.002 53.0987 161.202 53.1989C161.804 53.3993 162.204 54.1007 162.104 54.9023ZM162.104 54.9023C162.104 54.8021 162.104 54.9023 162.104 54.9023Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2812 83.0584C50.2812 81.355 50.2812 79.6516 51.4836 79.1506C52.7862 78.6496 53.4876 79.852 54.4896 81.5554C55.3914 83.0584 54.9906 84.6616 53.688 85.1626C52.5858 85.6636 50.2812 85.363 50.2812 83.0584Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9829 74.6416C50.7825 76.7458 50.4819 77.9482 51.7845 78.4492C53.0871 78.9502 53.7885 77.848 55.0911 76.2448C56.0931 74.842 55.3917 73.0384 54.0891 72.5374C52.7865 72.0364 51.1833 72.9382 50.9829 74.6416Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8804 78.6497C49.8804 77.8481 50.4816 77.2469 51.183 77.1467C51.4836 77.0465 51.8844 77.0465 52.2852 77.1467C53.8884 77.2469 55.2912 78.1487 55.191 79.1507C55.0908 80.1527 53.7882 80.8541 52.0848 80.6537C51.7842 80.6537 51.4836 80.5534 51.183 80.4532C50.3814 80.353 49.8804 79.5515 49.8804 78.6497Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6938 78.9503C67.2148 78.9503 86.6536 85.0625 86.9542 107.507",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4_563",
    x: 0.880371,
    y: 0.00012207,
    width: 210.238,
    height: 203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.513726 0 0 0 0 0.556863 0 0 0 0 0.619608 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_563"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 0.403922 0 0 0 0 0.431373 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4_563",
    result: "effect2_dropShadow_4_563"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4_563",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvoicesIcon);
export default __webpack_public_path__ + "static/media/NoInvoicesIcon.e0a7ada994775e165c1c361973b9a829.svg";
export { ForwardRef as ReactComponent };